import md5 from 'md5';

const get_gravatar_image_url = (email: string, size?: number, default_image?: any, allowed_rating?: any, force_default?: any) => {
  email = typeof email !== 'undefined' ? email : '';
  size = size >= 1 && size <= 2048 ? size : 80;
  default_image = typeof default_image !== 'undefined' ? default_image : 'blank';
  allowed_rating = typeof allowed_rating !== 'undefined' ? allowed_rating : 'g';
  force_default = force_default === true ? 'y' : 'n';

  return (
    'https://secure.gravatar.com/avatar/' +
    md5(email.toLowerCase().trim()) +
    '?size=' +
    size +
    '&default=' +
    encodeURIComponent(default_image) +
    '&rating=' +
    allowed_rating +
    (force_default === 'y' ? '&forcedefault=' + force_default : '')
  );
};

export class Gravatar {
  static fetchImage(email: string) {
    const gravatar_image_url = get_gravatar_image_url(email, 80);
    return gravatar_image_url;
  }
}
